import { TOKEN_KEY, WEB_POLICIES } from 'common/constants/authConstants';

export const getLocalToken = () => localStorage[TOKEN_KEY];
export const getPoliciesToken = () =>
  sessionStorage[WEB_POLICIES] ? sessionStorage[WEB_POLICIES] : '';
